export {default as proc} from 'process'
